import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChatShellComponent } from '../../components/chat-shell/chat-shell.component';

@Component({
  selector: 'app-chat-view',
  imports: [ChatShellComponent],
  templateUrl: './chat-view.component.html',
  styleUrl: './chat-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatViewComponent {}
